import React from "react";
import Search from "@mui/icons-material/Search";
import Close from "@mui/icons-material/Close";
import { AddOriginSearchOption } from "../../../../types/IFavoriteOrigins";
import LoadingIcon from "../../../../components/Loading";

export type AddOriginOption = AddOriginSearchOption & {
  hasExistingRowForLocation: boolean;
};

interface OriginManagerHeaderProps {
  addOriginButtonRef: React.RefObject<HTMLButtonElement>;
  isAddOriginTourVisible: boolean;
  onAddOriginButtonClick: () => void;
  isAddOriginOpen: boolean;
  addOriginPopoverRef: React.RefObject<HTMLDivElement>;
  addOriginInputRef: React.RefObject<HTMLInputElement>;
  addOriginQuery: string;
  onAddOriginQueryChange: (value: string) => void;
  onClearAddOriginSearch: () => void;
  optionsLoading: boolean;
  isAddingOriginLoading: boolean;
  filteredAddOriginOptions: AddOriginOption[];
  onSelectAddOriginOption: (option: AddOriginOption) => void;
}

const OriginManagerHeader: React.FC<OriginManagerHeaderProps> = ({
  addOriginButtonRef,
  isAddOriginTourVisible,
  onAddOriginButtonClick,
  isAddOriginOpen,
  addOriginPopoverRef,
  addOriginInputRef,
  addOriginQuery,
  onAddOriginQueryChange,
  onClearAddOriginSearch,
  optionsLoading,
  isAddingOriginLoading,
  filteredAddOriginOptions,
  onSelectAddOriginOption,
}) => {
  return (
    <div className="dom-header-row">
      <div className="dom-header-left">
        {/* <OriginManagerIcon /> */}
        <h2 className="dom-title">Origin Manager</h2>
      </div>

      <div className="dom-add-origin-wrap" ref={addOriginPopoverRef}>
        {/* {isEditingPrices && (
          <button
            id="cancel-editing-prices"
            type="button"
            className="dom-inline-cancel-edit-btn"
            onClick={onCancelEdit}
          >
            Cancel
          </button>
        )} */}

        <button
          ref={addOriginButtonRef}
          type="button"
          className={`dom-add-origin-button${
            isAddOriginTourVisible
              ? " dom-add-origin-button--tour-highlight"
              : ""
          }`}
          onClick={onAddOriginButtonClick}
          aria-expanded={isAddOriginOpen}
          aria-haspopup="listbox"
        >
          <span className="dom-add-origin-plus">+</span>
          <span>Add Origin</span>
        </button>

        {isAddOriginOpen && (
          <div
            className="dom-add-origin-popover"
            role="dialog"
            aria-label="Add Origin"
          >
            <div className="dom-add-origin-popover-header">
              ADD KOCH AND COMPETITOR ORIGINS
            </div>

            <div className="dom-add-origin-search-row">
              <Search className="dom-add-origin-search-icon" />
              <input
                ref={addOriginInputRef}
                className="dom-add-origin-input"
                type="text"
                value={addOriginQuery}
                onChange={(event) => onAddOriginQueryChange(event.target.value)}
                placeholder=""
              />
              <button
                type="button"
                className="dom-add-origin-clear-btn"
                onClick={onClearAddOriginSearch}
                aria-label="Clear search"
              >
                <Close className="dom-add-origin-clear-icon" />
              </button>
            </div>

            <div
              className="dom-add-origin-options"
              role="listbox"
              aria-label="Origin options"
            >
              {(optionsLoading || isAddingOriginLoading) && (
                <div
                  className="dom-add-origin-loader"
                  role="status"
                  aria-live="polite"
                >
                  <LoadingIcon color="#005CA6" height={36} width={36} />
                </div>
              )}
              {!optionsLoading &&
                !isAddingOriginLoading &&
                filteredAddOriginOptions.length === 0 && (
                  <div className="dom-add-origin-empty">
                    {addOriginQuery.trim()
                      ? "No matching origins"
                      : "No origins available to add"}
                  </div>
                )}
              {!optionsLoading &&
                !isAddingOriginLoading &&
                filteredAddOriginOptions.length > 0 &&
                filteredAddOriginOptions.map((option, index) => (
                  <button
                    key={option.id}
                    type="button"
                    className={
                      index === 0
                        ? "dom-add-origin-option dom-add-origin-option-active"
                        : "dom-add-origin-option"
                    }
                    onClick={() => onSelectAddOriginOption(option)}
                    disabled={isAddingOriginLoading}
                  >
                    {option.name}
                  </button>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OriginManagerHeader;
